<template lang="">
  <div>
    <v-sheet
      tabindex="0"
      width="100%"
      class="pa-2"
      ref="dropzone"
      :class="{ 'dashed-border': currentDirectory.name !== '/' }"
    >
    <div
      class="text-left pt-12"
      v-if="currentDirectory.name !== '/' && currentDirectory.files.length == 0"
    >
      Aucune pièce jointe n'a été ajoutée.
    </div>
    <v-row>
      <v-col cols="4" v-for="(file, index) in currentDirectory.files" v-bind:key="index">
        <p>
          <a
            :class="{ 'mr-1': index < currentDirectory.files.length - 1 }"
            :href="urlPrefix + file.chemin"
            target="_blank"
          >
          <img
            v-if="file.name.split('.').pop() == 'pdf'"
            src="@/assets/pdf.png"
            alt=""
          />
          <img
            v-else-if="
              file.name.split('.').pop().substring(0, 3) == 'doc' ||
              file.name.split('.').pop().substring(0, 3) == 'txt'
            "
            src="@/assets/doc.png"
            alt=""
          />
          <img
            v-else-if="
                file.name.split('.').pop().substring(0, 3) == 'xls' ||
                file.name.split('.').pop().substring(0, 3) == 'csv'
              "
              src="@/assets/excel.png"
              alt=""
            />
            <img v-else src="@/assets/img.png" alt="" />
          </a>
        </p>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <p v-if="file.name.length > 15" v-bind="attrs" v-on="on">{{ file.name.substring(file.name.indexOf('-') + 1).substring(0, 15)}}</p>
            <p v-else v-bind="attrs" v-on="on">{{ file.name.substring(file.name.indexOf('-') + 1)}}</p>
          </template>
          <span>{{file.name.substring(file.name.indexOf('-') + 1)}}</span>
        </v-tooltip>
        <p>ajouté le : {{$moment(file.lastModified).format('DD/MM/YYYY')}}</p>
        <p><v-btn v-if="mode !== 'visualisation'"  @click="deleteDocument(file, index, true)"><strong>Supprimer</strong></v-btn></p>
      </v-col>
    </v-row>
    </v-sheet>

    <Popup :dialog="dialog" text="Supprimer ce document ?" actions="" heightProp="" widthProp="" @emitDialog="dialog = $event" showClose="false">
      <v-card-actions class="mb-10">
        <v-btn class="actions mr-10" color="#0B87BA" width="100px"  large dark rounded @click="dialog = false">Non</v-btn>
        <v-btn class="actions" color="#0B87BA" width="100px" large dark rounded @click="deleteDocument(file, index, false)">Oui</v-btn>
      </v-card-actions>
    </Popup>
  </div>
</template>
<script>
import api_doc from "@/api/document";
import Popup from "@/components/shared/Popup";
export default {
  props: {
    mode: [String],
    currentDirectory: {
      type: Object,
    },
  },
  components: { Popup },

  data() {
    return {
      urlPrefix: process.env.VUE_APP_BASE_URL,
      documentToDelete: null,
      indexToDelete: null,
      dialog: false,
    };
  },

  computed: {
    projectId() {
      return this.$route.params.id_projet;
    },
  },

  methods: {
    deleteDocument(document, index, open) {
      if (open) {
        this.documentToDelete = document;
        this.indexToDelete = index;
        this.dialog = true;
      } else {
        if (this.documentToDelete.chemin !== undefined && this.documentToDelete.saved) {
          api_doc
            .deleteProjectDocument(this.projectId, this.documentToDelete)
            .then(() => {
              this.currentDirectory.files.splice(index, 1);
            }).catch(() => {
              this.$store.dispatch('notify', { message: 'Erreur lors de la suppression' });
            });
        } else {
          this.currentDirectory.files.splice(index, 1);
        }
        this.dialog = false;
      }
    },
  },

  mounted() {
    const dropzone = this.$refs.dropzone.$el;

        // register listeners on your dropzone / v-sheet
    if(dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener("dragenter", e => { [2]
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener("dragleave", e => { [2]
        e.preventDefault()
        this.dragover = false
      })
      dropzone.addEventListener("dragover", e => { [2]
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener("drop", e => { [3]
        e.preventDefault()
        const dragevent = e
        if(dragevent.dataTransfer) {
          for (const file of dragevent.dataTransfer.files) {
            this.selectedFile = file;
            this.$emit('emitFile', file);
          }
        }
      })
    }

  },
};
</script>
<style scoped>
.dashed-border {
  border: 1px dashed black;
  min-height: 150px;
}

.calendar-field {
  width: 20%;
}

img {
  width: 29px;
  height: 28px;
}

.font_color {
  font-weight: bold;
  color: #ffffff;
}

.width-50 {
  width: 30%;
}

.addPersonne {
  border-style: dashed;
  border-color: blue;
  color: blue;
}

.btnBold {
  font-weight: bold;
}

.errorMsg {
  text-align: left;
  color: red;
}

::v-deep .v-breadcrumbs__item {
	align-items: center;
	display: inline-flex;
	text-decoration: none;
	transition: .3s cubic-bezier(.25,.8,.5,1);
	color: blue;
}

.active {
  cursor: pointer;
  font-weight: bold;
}

::v-deep .v-breadcrumbs__divider{
  font-weight: bold;
  color: blue!important;
}

.disable{
  font-weight:normal!important
}

.v-breadcrumbs li .v-icon {
	font-size: 16px;
	color: blue;
}

::v-deep .linkProjet{
  list-style-type:square 
}

.linkProjet a{
    color:#4B4B4B;
}

a div:nth-child(2){
  color:#4B4B4B;
}

a.linkProjet{
text-decoration:none;
}

.test3 {
  font-size: x-small;
}
</style>
